import React, { useEffect } from 'react';
import { a } from '@react-spring/web';
import contil from '../../../img/contil_logo1.png';
import tbf from '../../../img/tbf.png';
import agc from '../../../img/agc.png';
import cp59 from '../../../img/cp59.png';
import wh from '../../../img/wh.png';
import casablanca from '../../../img/casablanca.png';
import { useStore } from '../store';
const content = [
  {
    name: 'WebGL/ThreeJs Developer',
    location: 'USA',
    imageFlag:
      'https://em-content.zobj.net/thumbs/160/apple/124/flag-for-united-states_1f1fa-1f1f8.png',
    image: casablanca,
    imageWidth: 200,
    top: 40,
    left: 60,
    time: 'May 2018 - Present',
    scaleTexture: [0.5, 0.5, 0.5],
    color: 'black',
    titleColor: 'black',
    backgroundColor: 'white',

    description: [
      `🔥	Develop and optimize 3D interactive applications for web browsers`,
      `    using Threejs, React-Three-Fiber, Nodejs`,
      `🔥	Develop web application for real estate using Threejs, `,
      `React-Three-Fiber, ReactJs, Mapbox, Google Photorealistic`,
      `🔥	Design UI/UX for 3D interactive applications using ReactJs`,
      `🔥	Create pipelines for Three.js and improve efficiency using Nodejs,`,
      ` Threejs, Puppeteer, …`
    ],
  },
  {
    name: 'Lead Full-stack Developer',
    time: 'Aug 2019 - July 2023',
    location: 'Singapore',
    imageFlag:
      'https://em-content.zobj.net/thumbs/160/apple/124/flag-for-united-states_1f1fa-1f1f8.png',
    image: wh,
    imageWidth: 200,
    top: 25,
    left: 60,
    scaleTexture: [0.8, 0.8, 0.8],

    color: 'black',
    titleColor: '#E8B059',
    backgroundColor: 'white', //'#E8B059',

    description: [
      `🔥	Research and develop Blockchain application (DAO) and Avalanche Subnet `,
      `using Nodejs, ReactJs, Solidity, Hardhat, Web3Js,EtherJs, AWS, PostgreSQL, …`,
      `🔥	Research and develop Metaverse-NFT applications using NodeJs, ReactJS, `,
      ` ThreeJs, WebSocket, WebRTC, WebXR, PostgreSQL, Ethereum, Web3js … `,

      `🔥	Research and develop Computer vision application using microservice`,
      ` (NodeJs, Fast API, ASP.Net Core), ReactJS, PostgreSQL, Docker, TensorFlow, …`,
      `🔥	Research and develop web application for BIM using Nodejs, ReactJs,`,
      ` Autodesk Forge API, …`
    ],
  },
  {
    name: 'Research Fellow',
    location: 'South Korea',
    time: 'Aug 2021 - June 2023',
    image: contil,
    imageWidth: 150,
    top: 15,
    left: 60,
    scaleTexture: [1, 1, 1],

    color: 'black',
    titleColor: '#6FA8DC',
    backgroundColor: 'white', //'#6FA8DC',

    description: [
      `🔥	Develop web application for construction management using Nodejs, `,
      `React, AWS DocumentDB, …`,
      `🔥	Develop digital checklist application using Asp.Net Core, ReactJS,`,
      ` PostgreSQL, …`,
      `🔥	Develop 3D viewer for BIM using Nodejs, ReactJs, Autodesk Forge API,`,
      ` Trimble Connect API, PostgreSQL, …`,
      `🔥	Research and develop add-in for Revit, Navisworks, Tekla using C#.`,
      `🔥	Mentor and review code of team members.`,
      `🔥	Create pipeline and solution architecture for team.`,
    ],
  },
  {
    name: 'BIM Developer',
    time: 'Dec 2017 - Jul 2019 ',
    location: 'Vietnam',
    imageFlag:
      'https://em-content.zobj.net/thumbs/160/apple/124/flag-for-united-states_1f1fa-1f1f8.png',

    image: tbf,
    imageWidth: 100,
    top: 25,
    left: 60,
    scaleTexture: [1, 1, 1],

    color: 'black',
    titleColor: 'black',
    backgroundColor: 'white',

    description: [
      `🔥	Develop augmented reality and virtual reality for construction `,
      `using Unity3D, C#`,
      `🔥	Develop web application for 3D viewer using Nodejs, ReactJs,`,
      ` MongoDB, Autodesk Forge API, …`
    ],
  },
  {
    name: 'BIM Engineer',
    time: 'Jun 2017 - Dec 2017',
    location: 'Vietnam',
    imageFlag:
      'https://em-content.zobj.net/thumbs/160/apple/124/flag-for-united-states_1f1fa-1f1f8.png',
    image: agc,
    imageWidth: 100,
    top: 13,
    left: 60,
    scaleTexture: [1, 1, 1],

    color: 'black',
    titleColor: '#E06666',
    backgroundColor: 'white',

    description: [
      `🔥	Research and develop add-in for BIM application using C#`,
      `🔥	Support technology and process`,
    ],
  },
];
export default function Overlay({ fill }) {
  const { page, setExperienceContent } = useStore();
  useEffect(() => {
    setExperienceContent(content);
  }, []);
  return (
    <div className="overlay">
      <div
        style={{
          top: content[page].top,
          left: content[page].left,
          display: 'flex',
          position: 'absolute',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ top: content[page].top, left: content[page].left }}>
          <img width={content[page].imageWidth} src={content[page].image} />
        </div>
        <div className="bql-time-span">
          <span style={{ color: content[page].color }}>
            {content[page].time}
          </span>
        </div>
      </div>

      <a.svg
        viewBox="0 0 700 720"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          fill={content[page].titleColor}
          style={{ whiteSpace: 'pre' }}
          fontFamily="Inter"
          fontSize={45}
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x={40} y={200} children={`${content[page].name} \u2014 `} /> 
   
        </text>
        <text
          style={{ whiteSpace: 'pre' }}
          fontFamily="Inter"
          fontSize={12}
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x={40} y={200} />
        </text>

        {content[page].description.map((v, k) => (
          <text
            fill={content[page].color}
            // style={{ whiteSpace: "pre", wordBreak:'break-all' }}
            fontFamily="Inter"
            fontSize={18}
            fontWeight="bold"
            letterSpacing="0em"
          >
            {/* {content[page].description.map((v,k)=>
        
           )} */}
            <tspan x={40} y={250 + k * 51} children={v} />
            {/* <tspan x={40} y={372.909} children="Blockchain " />
         <tspan x={40} y={423.909} children="VR/AR " />
         <tspan x={40} y={474.909} children="Develop BIM application" /> */}
            {/* <tspan x={40} y={525.909} children="power of this our " />
         <tspan x={40} y={576.909} children="pentacle;" /> */}
          </text>
        ))}
      </a.svg>
    </div>
  );
}
